import React from 'react';
import styled from 'styled-components';
import I10n from '../../features/i10n';
import Button from '../../atoms/button';
import LicenseComparatorTable from './license_comparator_table';
import MobileLicenseComparatorTable from './mobile_license_comparator_table';
import ProductLink from '../product_link';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

const Title = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 10px;
`;

const CardGroupWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex:  1 1 0px;
  margin-right: -20px;
  @media (max-width: 800px) {
    flex-direction: column;
    margin-right: 0px;
  }
`;

const CardItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  margin-right: 10px;
  min-width: calc(33% - 10px);
  width: calc(33% - 10px);
  max-width: calc(33% - 10px);
  color: #000000;
  box-sizing: border-box;

  @media (max-width: 800px) {
    flex: unset;
    min-width: unset;
    width: auto;
    max-width: unset;
    margin-right: 0px;
  }
  padding: 20px;
  border-radius: 8px;
  background-color: white;
`;

const CardTitle = styled.span`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
`;

const CardSubtitle = styled.span`
  display: flex;
  flex: 1 1 0px;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 20px;
`;

const CardActionWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 800px) {
    flex-direction: column-reverse;
  }
`;

const CardButtonWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  justify-content: flex-end;
   qds-button {
    --qds-internal-white-space-property: pre-wrap;
  }
`;

const SUBGROUP_RENDER_TYPES = {
  TAB: 'Tab',
  CARD: 'Card'
};

class LicenseSubGroup extends React.Component {

  renderCardSubGroupItems(licenseSubGroup) {
    return (<CardGroupWrapper>
      {licenseSubGroup.comparatorTypes.map((type) => {
        return (
          <CardItem key={type.comparatorTypeKey}>
            <CardTitle>{I10n.getOrDefault(`screen.licence_selector.comparator_type.name.${type.labelKey}`, type.comparatorTypeName)}</CardTitle>
            <CardSubtitle>{I10n.getOrDefault(`screen.licence_selector.comparator_type.description.${type.labelKey}`, type.description)}</CardSubtitle>
            <CardActionWrapper>
              {this.props.knowMoreLinksMap[type.scopedKnowMoreReferences[0].id] && <ProductLink fullLink={this.props.knowMoreLinksMap[type.scopedKnowMoreReferences[0].id]} label={I10n.get('screen.licence_selector.know_more')}></ProductLink>}
              <CardButtonWrapper>
                {type.licenseTypesKey && <Button importance="emphasized" disabled={this.props.isSaving} onClick={() => {
                  this.props.onAddSoftwareLicencesRequested(type);
                }}>
                  {I10n.getOrDefault(`screen.licence_selector.configure_and_buy.${this.props.softwareSelection}`, I10n.get('screen.licence_selector.configure_and_buy'))}
                </Button>}
              </CardButtonWrapper>
            </CardActionWrapper>
          </CardItem>
        );
      })}

    </CardGroupWrapper>);
  }

  renderSubGroupItems(licenseSubGroup) {
    let renderFunction = () => <></>;
    const mapTypeToRenderFunction = {
      [SUBGROUP_RENDER_TYPES.TAB]: () => {
        const props = {
          licenseSubGroup: licenseSubGroup,
          isSaving: this.props.isSaving,
          onAddSoftwareLicencesRequested: this.props.onAddSoftwareLicencesRequested,
          knowMoreLinksMap: this.props.knowMoreLinksMap,
          softwareSelection: this.props.softwareSelection
        };
        return (
          <>
           <LicenseComparatorTable {...props}/>
           <MobileLicenseComparatorTable {...props}/>
          </>
       );
      },
      [SUBGROUP_RENDER_TYPES.CARD]: () => {
        return this.renderCardSubGroupItems(licenseSubGroup);
      }
    }

    if (mapTypeToRenderFunction[licenseSubGroup?.subGroupType]) {
      renderFunction = mapTypeToRenderFunction[licenseSubGroup?.subGroupType];
    }

    return renderFunction();
  }

  render() {
    const {
      licenseSubGroup,
    } = this.props;

    return (
      <Container>
        {licenseSubGroup.subGroupName && <Title>{I10n.getOrDefault(`screen.licence_selector.sub_group.name.${licenseSubGroup.labelKey}`, licenseSubGroup.subGroupName)}</Title>}
        {this.renderSubGroupItems(licenseSubGroup)}
      </Container>
    );
  }
}

export default LicenseSubGroup;
